<template>
<div>
<!--  <loading v-show="showLoader" />-->
  <div class="ib-main-section">
    <div class="container">
<!--      <router-link class="ib-back-btn" :to="{ name: 'PolicyServicing' }">Back</router-link>-->
      <a class="ib-back-btn" href="#" @click="$router.back()">Back</a>
      <div class="row">
        <div class="col-md-6 pl-0">
          <div style="padding-top: 77px;">
            <h2 class="listing-page-title">Policy Servicing</h2>
<!--            <p class="listing-page-desc text-capitalize">{{ type.toLowerCase().split("_").join(" ") }} request</p>-->

          </div>
        </div>
        <div class="col-md-6 in-page-infographic">
          <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
        </div>
      </div>
    </div>
    <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
      <div class="row mb-4">
        <div class="col-12 ib-border-b in-lg-pb--fix">
          <ul class="list-inline in-list-inline-risk--fix">

            <form action="" class="float-md-right ml-md-auto list-position">
              <li class="list-inline-item">
                <div class="in-risk-title-dropdown in-risk-title-dropdown--fix">
                  <select style="width: 100% !important;" class="floating-select in-dropdown-per-page" @change="onChange($event)">
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                  </select>
                  <span class="highlight"></span>
                  <div class="ib-custom-select"></div>
                </div>
              </li>
              <li class="list-inline-item">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <div class="jbl-field in-search-field">
                      <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here..." v-on:keyup="filterSearch" v-model="searchKey"/>
                    </div>
                  </li>
                  <li>
                  </li>
                  <li class="list-inline-item">
                    <div class="field jbl-responsive-btn">
                      <span v-on:click="donloadPDF()" class="ib-btn-primary ib-btn-width ib-btn-hover"> PDF </span>
                    </div>
                  </li>
                  <li class="list-inline-item">
                    <div class="field jbl-responsive-btn">
                      <router-link :to="{ name: 'Products' }" class="ib-btn-primary ib-btn-width ib-btn-hover">ADD POLICY</router-link>
                    </div>
                  </li>
                  <li class="list-inline-item">
                    <div class="field jbl-responsive-btn"  v-on:click="deleteRisks()">

                      <a class="ib-delete-btn del_btn_comprehensive in-cursor-pointer" :class="temporaryDeleteRisks.length === 0 ? 'ib-not-allowed-2': ''" style="cursor: pointer !important;" v-if="temporaryDeleteRisks.length === 0" content="Select Risk To Delete" v-tippy>
                        <span >
                          <i class="fa fa-trash in-fa-trash in-fa-trash--fix"></i>
                          </span>
                      </a>

                      <a class="ib-delete-btn del_btn_comprehensive" style="cursor: pointer !important;" v-else content="Submit Deleted Risk" v-tippy>
                        <span >
                          <i class="fa fa-trash in-fa-trash in-fa-trash--fix"></i>
                        </span>
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
            </form>
          </ul>
        </div>
        <div class="col-md-12 d-none d-md-block">
          <table class="claim-listing">
            <tbody>
            <tr v-for="(risk_listing,index) in dispalyItems" :key="index" @click="RemoveRisk(risk_listing.id)">
              <td class="jbl-responsive-td data-img">
                <div class="in-listing-img">
                  <img class="img-fluid"/>
                  <div class="position-relative-box">
                    <img alt="icon" class="img-fluid small-icon" :src="policy_detail.product_image" />
                  </div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Risk ID:</div>
                  <div class="jbl-date-td">{{ risk_listing.id}}</div>
                </div>
              </td>
              <td class="jbl-responsive-td" v-if="risk_listing.form_data.stage_3[0].label !=''">
                <div class="jbl-flex-td">
<!--                  <div class="jbl-date-td jbl-date-heading">Paid Amount</div>-->
                  <div class="jbl-date-td jbl-date-heading"><span>{{risk_listing.form_data.stage_3[0].label}}</span></div>
                  <div class="jbl-date-td ib-td-currency"><span>{{risk_listing.form_data.stage_3[0].value}}</span></div>

                </div>
              </td>
              <td class="jbl-responsive-td" v-if="risk_listing.form_data.stage_3[1].label !=''">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading"><span>{{risk_listing.form_data.stage_3[1].label}}</span></div>
                  <div class="jbl-date-td ib-td-currency"><span>{{risk_listing.form_data.stage_3[1].value}}</span></div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Policy Date</div>
                  <div class="jbl-date-td ib-td-currency"><span>{{formatDate(risk_listing.created_at)}}</span></div>
                </div>
              </td>

<!--              <td class="jbl-responsive-td data-img">-->
<!--                <div class="in-listing-img">-->
<!--                  <img class="img-fluid"/>-->
<!--                  <div class="position-relative-box">-->
<!--                    <img alt="icon" class="img-fluid small-icon" :src="policy_detail.product_image" />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
              <td class="jbl-responsive-td in-action-btn-risk">
                <div class="ijbl-flex-td" @click="ViewRisk(risk_listing.id)" content="View risk detail" v-tippy>
                  <!-- <button class="btn btn-success">View</button> -->
                  <i class="fa fa-eye in-fa-eye"></i>
                </div>
                <a class="ib-delete-btn del_btn_comprehensive"  :class="temporaryDeleteRisks.indexOf(risk_listing.id) !== -1 ? 'active' : ''"  :content="temporaryDeleteRisks.indexOf(risk_listing.id) !== -1 ? 'Undo' : 'Delete'" v-tippy>
                  <span >
                    <!-- <img class="img-fluid" :src="require('@/assets/images/delete.svg')"/> -->
                    <i class="fa fa-trash in-fa-trash"></i>
                    </span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center;" v-if="customer_self_policies_filterd.length === 0">No Policy Found</h2>
          <PaginationComponent v-if="isShowing" @updatePage="changePage" @updatedData="getName" :chunkSize="chunkSize" :customer_self_policies_filterd="customer_self_policies_filterd"/>

        </div>
        <!-- mobile view -->
          <div class="col-md-12 d-md-none pt-4">
            <div class="d-flex in-sm-listing" v-for="(risk_listing,index) in dispalyItems" :key="index" @click="RemoveRisk(risk_listing.id)">
              <div class="in-sm-firstdiv">
                <div class="in-listing-img in-sm-height">
                  <img class="img-fluid" :src="policy_detail.product_image" />
                  <!-- <img class="img-fluid" :src="self_claim.product_image" v-else /> -->
                  <div class="position-relative-box">
                  <img alt="icon" class="img-fluid small-icon" :src="policy_detail.company.logo" />
                  </div>
                </div>
              </div>
              <div class="in-sm-flex1">
                <div class="d-flex in-sm-date">
                  <div>Policy Date:&nbsp;</div>
                  <div>{{formatDate(risk_listing.created_at)}}</div>
                </div>
                <!-- <div class="in-sm-title" v-if="self_claim.plan_name !== ''">{{ self_claim.subclass_name }}
                  <small>{{ self_claim.product_name }}</small>
                  <small class="ib-card-plan">{{ self_claim.plan_name }}</small>
                </div>
                <div class="in-sm-title" v-else>{{ self_claim.subclass_name }}
                  <small class="ib-card-plan">{{ self_claim.product_name }}</small>
                </div> -->
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Risk ID:</div>
                    <div class="in-sm-value">{{ risk_listing.id}}</div>
                  </div>
                </div>
                <div class="jbl-responsive-td in-action-btn-risk">
                <div class="ijbl-flex-td" @click="ViewRisk(risk_listing.id)" content="View risk detail" v-tippy>
                  <!-- <button class="btn btn-success">View</button> -->
                  <i class="fa fa-eye in-fa-eye"></i>
                </div>
                <a class="ib-delete-btn del_btn_comprehensive"  :class="temporaryDeleteRisks.indexOf(risk_listing.id) !== -1 ? 'active' : ''"  :content="temporaryDeleteRisks.indexOf(risk_listing.id) !== -1 ? 'Undo' : 'Delete'" v-tippy>
                  <span >
                    <!-- <img class="img-fluid" :src="require('@/assets/images/delete.svg')"/> -->
                    <i class="fa fa-trash in-fa-trash"></i>
                    </span>
                </a>
              </div>
                  <!-- <div class="in-sm-status ib-status" :class="self_claim.status +'-status'">{{ self_claim.status }}</div> -->
              </div>
            </div>
            <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center;" v-if="customer_self_policies_filterd.length === 0">No Policy Found</h5>
            <PaginationComponent v-if="isShowing" @updatePage="changePage" :chunkSize="chunkSize"  :customer_self_policies_filterd="customer_self_policies_filterd" :isShowing="isShowing"/>
          </div>

        <!-- mobile view -->
      </div>
      <!--  View Risks  -->
      <!-- End of View Risks  -->
    </div>
  </div>
</div>
</template>
<script>
import loading from '@/components/Loading/Loading'
import moment from "moment";
import axios from 'axios';
import PaginationComponent from "../../../components/PaginationComponent";
export default{
    name: 'PolicyServicingDelete',
    components :{
      loading,
      PaginationComponent,
    },
    data(){
      return{
        type: this.$route.params.type,
        endorsement_types: {},
        endorsement_id: this.$route.params.id,
        quotation_id: this.$route.params.quotation_id,
        risks:{},
        policy_detail:{},
        filterPolicyRisks:{},
        searchKey:'',
        temporaryDeleteRisks:[],
        currentPage:0,
        dispalyItems:[],
        name:'',
        isShowing : true,
        customer_self_policies_filterd:{},
        chunkSize: 10,
      }
    },
    created: function(){
      const self =this;
      self.riskListing(self.quotation_id);
      self.policyDetail(self.quotation_id);
    },
  methods:{
    onChange(e){
      const self =this;
      self.chunkSize = parseInt(e.target.value);
    },
    getName(name){
      this.dispalyItems = name;
    },
    changePage(value){
      this.currentPage = value;
    },
    donloadPDF: async function () {
      const self = this;
      self.showLoader = true;
      var formData = new FormData();
      formData.append('customer_quotation_id', this.$route.params.quotation_id);
      await axios.post('customer/risks_listing/pdf', formData).then(function (resp) {
        self.showLoader = false;

        if (resp.data.code == 200) {
          window.open(resp.data.risks, '_blank');
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
    },
    RemoveRisk: function (risk_id){
      const self = this;
      let index = self.temporaryDeleteRisks.indexOf(risk_id);
      if (index !== -1) {
        self.temporaryDeleteRisks.splice(index, 1);
        self.$forceUpdate();
      } else {
        self.temporaryDeleteRisks.push(risk_id);
        self.$forceUpdate();
      }
    },
    async riskListing(id) {
      const self = this;
      self.showLoader = true;
      await axios.get('customer/risks_listing?form_data=1&customer_quotation_id=' + id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.risks = resp.data.risks;
          self.customer_self_policies_filterd = self.risks;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async policyDetail(id){
      const self = this;
      self.showLoader = true;
      await axios.get('customer/policy_detail?id=' + id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.policy_detail = resp.data.data;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    filterSearch: function () {
      const self = this;

      if (self.searchKey == ''){
        self.customer_self_policies_filterd = self.risks;
        return false;
      }
      self.filterPolicyRisks = self.risks.filter(x => x.id === parseInt(self.searchKey));
      self.customer_self_policies_filterd = self.filterPolicyRisks;
    },
    deleteRisks(){
      const self = this;
      var formData = new FormData();
      formData.append('endorsement_type_id', self.endorsement_id);
      formData.append('customer_quotation_id', self.quotation_id);
      self.temporaryDeleteRisks.forEach(value => {
        formData.append('quotation_risk_ids[]', value);
      })
      if(self.temporaryDeleteRisks.length == 0){
        $toast.error('Please select at-least One Deleted Risk', {position: 'top-right'});
        return false;
      }else{
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f77c94',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post('customer/endorsement/risk_deletion',formData).then(function (resp) {
              self.showLoader = false;
              if (resp.data.code == 200) {
                $toast.success('Risk Remove Request Submitted Successfully !!!', { position: 'top-right' });
                self.$router.push({ name: 'Endorsements', params: { id: self.quotation_id } });

              } else {
                $toast.error(resp.data.message, { position: 'top-right' });
                self.$router.push({ name: 'Endorsements', params: { id: self.quotation_id } });
              }
            }).catch(function (error) {
              self.showLoader = false;
              if(error.response) {
                error.response.data.errors.forEach(element => {
                  $toast.error(element.message, { position: 'top-right' });
                });
              } else {
                $toast.error(error.data.message, { position: 'top-right' });
              }
            });
          }
        })
      }

    },
    async ViewRisk(id){
      const self = this;
      // self.$router.push({ name: 'ViewRisk', params: {id: id, quotation_id: self.quotation_id, type: self.type} });
       self.$router.push({ name: 'RiskView', params: {id: id, policyId: self.quotation_id } });
    }
    },
  }
</script>
<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
  .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child{
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }

  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active, .page-link active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  nav#inIbPagination > ul.pagination > li.page-item.d-flex > a.page-link.active{
    background-color: var(--primary-color) !important;
    color: white !important;
  }
  nav#inIbPagination{
    margin: 2rem auto 0rem;
  }
  nav#inIbPagination > ul.pagination span:not(.page-item){
    display: flex;
    flex: 1;
  }
  .in-sm-listing {
    min-height: 106px !important;
  }
  .in-sm-listing .in-action-btn-risk{
    justify-content: end;
  }
  a.ib-delete-btn.del_btn_comprehensive.active i.in-fa-trash,
  a.ib-delete-btn.del_btn_comprehensive.active:hover i.in-fa-trash,
  a.ib-delete-btn.del_btn_comprehensive.active:focus i.in-fa-trash{
    border-color: var(--primary-color) !important;
    background-color: var(--primary-color) !important;
    color: white !important;
  }
  /*button.swal2-confirm.swal2-styled{*/
  /*  min-height: 47px !important;*/
  /*}*/
</style>




// WEBPACK FOOTER //
// src/views/PolicyServicing/Risk/DeleteRisk.vue